import { getRoot, types } from 'mobx-state-tree'
import { RootModel } from '@shared/data-access'

export const MODEL_NAME = 'AllPolicyRecordings'

export const Model = RootModel.named(MODEL_NAME)
  .props({
    id: types.identifier,
    name: types.maybeNull(types.string),
    contractNumber: types.maybeNull(types.string),
    datetime: types.maybeNull(types.string),
    filename: types.maybeNull(types.string),
    format: types.maybeNull(types.string),
    size: types.maybeNull(types.number),
    source: types.maybeNull(types.string),
    url: types.maybeNull(types.string),
  })
  .volatile((self) => ({
    _store: getRoot(self)[`${MODEL_NAME}Store`],
  }))

export default Model
